import { Flex } from 'antd';

interface Props {
  title?: string;
  description?: string;
}

const UtilitySummary = ({ title, description }: Props) => {
  return (
    <Flex vertical>
      <h2 className="fw-bold">{title}</h2>
      <p>{description}</p>
    </Flex>
  );
};

export default UtilitySummary;
